

import { IKanjiComparisonTable } from './types';

/**
 * Code generated from @lazy-cjk/jp-table-comparison/lib/table/core.ts;
 * DO NOT EDIT.
 * @see {@link ./table/core.ts}
 */

export const TABLE: IKanjiComparisonTable = [
	[["会"],["會"],["会"]],
	[["箋"],["箋"],["笺"]],
	[["網"],["網"],["网"]],
	[["処"],["處"],["处"]],
	[["話"],["話"],["话"]],
	[["駄"],["馱"],["驮"]],
	[["馱"],["馱"],["驮"]],
	[["万"],["萬"],["万"]],
	[["与"],["與"],["与"]],
	[["醜"],["醜"],["丑"]],
	[["専"],["專"],["专"]],
	[["業"],["業"],["业"]],
	[["東"],["東"],["东"]],
	[["絲"],["絲"],["丝"]],
	[["糸"],["絲"],["丝"]],
	[["両"],["兩"],["两"]],
	[["厳"],["嚴"],["严"]],
	[["並"],["並"],["并"]],
	[["喪"],["喪"],["丧"]],
	[["個"],["個"],["个"]],
	[["豊"],["豐"],["丰"]],
	[["臨"],["臨"],["临"]],
	[["為"],["為"],["为"]],
	[["麗"],["麗"],["丽"]],
	[["挙"],["舉"],["举"]],
	[["廼"],["迺"],["迺"]],
	[["義"],["義"],["义"]],
	[["楽"],["樂"],["乐"]],
	[["乗"],["乘"],["乘"]],
	[["習"],["習"],["习"]],
	[["郷"],["鄉"],["乡"]],
	[["書"],["書"],["书"]],
	[["買"],["買"],["买"]],
	[["乱"],["亂"],["乱"]],
	[["乾"],["乾"],["干"]],
	[["亀"],["龜"],["龟"]],
	[["予"],["預"],["预"]],
	[["弐"],["貳"],["贰"]],
	[["雲"],["雲"],["云"]],
	[["亜"],["亞"],["亚"]],
	[["産"],["產"],["产"]],
	[["畝"],["畝"],["亩"]],
	[["親"],["親"],["亲"]],
	[["億"],["億"],["亿"]],
	[["僕"],["僕"],["仆"]],
	[["従"],["從"],["从"]],
	[["仏"],["佛"],["佛"]],
	[["倉"],["倉"],["仓"]],
	[["儀"],["儀"],["仪"]],
	[["仮"],["假"],["假"]],
	[["価"],["價"],["价"]],
	[["衆"],["眾"],["众"]],
	[["優"],["優"],["优"]],
	[["伝"],["傳"],["传"]],
	[["傘"],["傘"],["伞"]],
	[["偉"],["偉"],["伟"]],
	[["傷"],["傷"],["伤"]],
	[["倫"],["倫"],["伦"]],
	[["偽"],["偽"],["伪"]],
	[["体"],["體"],["体"]],
	[["余"],["餘"],["余"]],
	[["来"],["來"],["来"]],
	[["偵"],["偵"],["侦"]],
	[["側"],["側"],["侧"]],
	[["倹"],["儉"],["俭"]],
	[["倶"],["俱"],["俱"]],
	[["債"],["債"],["债"]],
	[["傾"],["傾"],["倾"]],
	[["償"],["償"],["偿"]],
	[["傑"],["傑"],["杰"]],
	[["備"],["備"],["备"]],
	[["当"],["當"],["当"]],
	[["尽"],["盡"],["尽"]],
	[["児"],["兒"],["儿"]],
	[["党"],["黨"],["党"]],
	[["内"],["內"],["内"]],
	[["関"],["關"],["关"]],
	[["興"],["興"],["兴"]],
	[["養"],["養"],["养"]],
	[["獣"],["獸"],["兽"]],
	[["円"],["圓"],["圆"]],
	[["写"],["寫"],["写"]],
	[["軍"],["軍"],["军"]],
	[["農"],["農"],["农"]],
	[["冨"],["富"],["富"]],
	[["氷"],["冰"],["冰"]],
	[["衝"],["衝"],["冲"]],
	[["決"],["決"],["决"]],
	[["凍"],["凍"],["冻"]],
	[["塗"],["塗"],["涂"]],
	[["凄"],["淒"],["凄"]],
	[["凄"],["悽"],["凄"]],
	[["准"],["準"],["准"]],
	[["準"],["準"],["准"]],
	[["幾"],["幾"],["几"]],
	[["撃"],["擊"],["击"]],
	[["画"],["劃"],["划"]],
	[["画"],["畫"],["画"]],
	[["則"],["則"],["则"]],
	[["剛"],["剛"],["刚"]],
	[["創"],["創"],["创"]],
	[["別"],["別"],["别"]],
	[["製"],["製"],["制"]],
	[["券"],["卷"],["卷"]],
	[["巻"],["卷"],["卷"]],
	[["刹"],["剎"],["刹"]],
	[["剤"],["劑"],["剂"]],
	[["剣"],["劍"],["剑"]],
	[["劇"],["劇"],["剧"]],
	[["剰"],["剩"],["剩"]],
	[["勧"],["勸"],["劝"]],
	[["務"],["務"],["务"]],
	[["動"],["動"],["动"]],
	[["励"],["勵"],["励"]],
	[["労"],["勞"],["劳"]],
	[["効"],["效"],[null]],
	[["勢"],["勢"],["势"]],
	[["勲"],["勳"],["勋"]],
	[["勝"],["勝"],["胜"]],
	[["区"],["區"],["区"]],
	[["医"],["醫"],["医"]],
	[["華"],["華"],["华"]],
	[["協"],["協"],["协"]],
	[["単"],["單"],["单"]],
	[["売"],["賣"],["卖"]],
	[["衛"],["衛"],["卫"]],
	[["庁"],["廳"],["厅"]],
	[["歴"],["歷"],["历"]],
	[["暦"],["曆"],["历"]],
	[["圧"],["壓"],["压"]],
	[["県"],["縣"],["县"]],
	[["参"],["參"],["参"]],
	[["双"],["雙"],["双"]],
	[["収"],["收"],["收"]],
	[["発"],["發"],["发"]],
	[["変"],["變"],["变"]],
	[["畳"],["疊"],["叠"]],
	[["号"],["號"],["号"]],
	[["嘆"],["嘆"],["叹"]],
	[["嚇"],["嚇"],["吓"]],
	[["聴"],["聽"],["听"]],
	[["啓"],["啟"],["启"]],
	[["員"],["員"],["员"]],
	[["諮"],["諮"],["谘"]],
	[["鹹"],["鹹"],["咸"]],
	[["響"],["響"],["响"]],
	[["問"],["問"],["问"]],
	[["営"],["營"],["营"]],
	[["噴"],["噴"],["喷"]],
	[["嘱"],["囑"],["嘱"]],
	[["蘇"],["蘇"],["苏"]],
	[["団"],["團"],["团"]],
	[["園"],["園"],["园"]],
	[["国"],["國"],["国"]],
	[["囲"],["圍"],["围"]],
	[["図"],["圖"],["图"]],
	[["圏"],["圈"],["圈"]],
	[["聖"],["聖"],["圣"]],
	[["場"],["場"],["场"]],
	[["壊"],["壞"],["坏"]],
	[["塊"],["塊"],["块"]],
	[["堅"],["堅"],["坚"]],
	[["壇"],["壇"],["坛"]],
	[["墳"],["墳"],["坟"]],
	[["墜"],["墜"],["坠"]],
	[["塁"],["壘"],["垒"]],
	[["墾"],["墾"],["垦"]],
	[["執"],["執"],["执"]],
	[["堕"],["墮"],["堕"]],
	[["報"],["報"],["报"]],
	[["塩"],["鹽"],["盐"]],
	[["増"],["增"],["增"]],
	[["壌"],["壤"],["壤"]],
	[["壮"],["壯"],["壮"]],
	[["声"],["聲"],["声"]],
	[["壱"],["壹"],["壹"]],
	[["殻"],["殻"],["壳"]],
	[["殼"],["殼"],["壳"]],
	[["寿"],["壽"],["寿"]],
	[["復"],["復"],["复"]],
	[["複"],["複"],["复"]],
	[["夢"],["夢"],["梦"]],
	[["頭"],["頭"],["头"]],
	[["誇"],["誇"],["夸"]],
	[["奪"],["奪"],["夺"]],
	[["奮"],["奮"],["奋"]],
	[["奨"],["獎"],["奖"]],
	[["粧"],["妝"],["妆"]],
	[["婦"],["婦"],["妇"]],
	[["姉"],["姐"],["姐"]],
	[["姫"],["姬"],["姬"]],
	[["嬢"],["孃"],["娘"]],
	[["娯"],["娛"],["娱"]],
	[["孫"],["孫"],["孙"]],
	[["学"],["學"],["学"]],
	[["寧"],["寧"],["宁"]],
	[["宝"],["寶"],["宝"]],
	[["実"],["實"],["实"]],
	[["審"],["審"],["审"]],
	[["憲"],["憲"],["宪"]],
	[["宮"],["宮"],["宫"]],
	[["寬"],["寬"],["宽"]],
	[["賓"],["賓"],["宾"]],
	[["秘"],["祕"],["秘"]],
	[["寛"],["寬"],["宽"]],
	[["寝"],["寢"],["寝"]],
	[["対"],["對"],["对"]],
	[["尋"],["尋"],["寻"]],
	[["導"],["導"],["导"]],
	[["将"],["將"],["将"]],
	[["層"],["層"],["层"]],
	[["属"],["屬"],["属"]],
	[["歳"],["歲"],["岁"]],
	[["島"],["島"],["岛"]],
	[["巌"],["巖"],["巖"]],
	[["峡"],["峽"],["峡"]],
	[["険"],["險"],["险"]],
	[["幣"],["幣"],["币"]],
	[["帥"],["帥"],["帅"]],
	[["師"],["師"],["师"]],
	[["帳"],["帳"],["帐"]],
	[["帶"],["帶"],["带"]],
	[["帯"],["帶"],["带"]],
	[["帰"],["歸"],["归"]],
	[["幹"],["幹"],["干"]],
	[["広"],["廣"],["广"]],
	[["庄"],["莊"],["庄"]],
	[["慶"],["慶"],["庆"]],
	[["庫"],["庫"],["库"]],
	[["応"],["應"],["应"]],
	[["廃"],["廢"],["废"]],
	[["開"],["開"],["开"]],
	[["弁"],["辨","瓣","辯"],["辨","瓣","辩"]],
	[["異"],["異"],["异"]],
	[["棄"],["棄"],["弃"]],
	[["弍"],["貳"],["贰"]],
	[["張"],["張"],["张"]],
	[["弥"],["彌"],["弥"]],
	[["強"],["強"],["强"]],
	[["弾"],["彈"],["弹"]],
	[["録"],["錄"],["录"]],
	[["彦"],["彥"],["彥"]],
	[["徹"],["徹"],["彻"]],
	[["徴"],["徵"],["征"]],
	[["径"],["徑"],["径"]],
	[["徳"],["德"],["德"]],
	[["憶"],["憶"],["忆"]],
	[["誌"],["誌"],["志"]],
	[["憂"],["憂"],["忧"]],
	[["懐"],["懷"],["怀"]],
	[["態"],["態"],["态"]],
	[["総"],["總"],["总"]],
	[["恒"],["恆"],["恒"]],
	[["恋"],["戀"],["恋"]],
	[["懇"],["懇"],["恳"]],
	[["恵"],["惠"],["惠"]],
	[["悪"],["惡"],["恶"]],
	[["悩"],["惱"],["恼"]],
	[["悦"],["悅"],["悅"]],
	[["懸"],["懸"],["悬"]],
	[["驚"],["驚"],["惊"]],
	[["惨"],["慘"],["惨"]],
	[["懲"],["懲"],["惩"]],
	[["愛"],["愛"],["爱"]],
	[["憤"],["憤"],["愤"]],
	[["願"],["願"],["愿"]],
	[["慮"],["慮"],["虑"]],
	[["戯"],["戲"],["戏"]],
	[["戦"],["戰"],["战"]],
	[["戸"],["戶"],["户"]],
	[["払"],["拂"],["拂"]],
	[["拡"],["擴"],["扩"]],
	[["掃"],["掃"],["扫"]],
	[["揚"],["揚"],["扬"]],
	[["抜"],["拔"],[null]],
	[["択"],["擇"],["择"]],
	[["護"],["護"],["护"]],
	[["担"],["擔"],["担"]],
	[["拝"],["拜"],["拜"]],
	[["擬"],["擬"],["拟"]],
	[["拠"],["據"],["据"]],
	[["擁"],["擁"],["拥"]],
	[["挟"],["挾"],["挟"]],
	[["揮"],["揮"],["挥"]],
	[["揷"],["插"],["插"]],
	[["挿"],["插"],["插"]],
	[["損"],["損"],["损"]],
	[["捨"],["捨"],["舍"]],
	[["掲"],["揭"],["揭"]],
	[["掴"],["摑"],["掴"]],
	[["揺"],["搖"],["摇"]],
	[["摂"],["攝"],["摄"]],
	[["撮"],["攝"],["摄"]],
	[["敵"],["敵"],["敌"]],
	[["敗"],["敗"],["败"]],
	[["数"],["數"],["数"]],
	[["斉"],["齊"],["齐"]],
	[["斎"],["齋"],["斋"]],
	[["闘"],["鬥"],["斗"]],
	[["鬪"],["鬥"],["斗"]],
	[["断"],["斷"],["断"]],
	[["旧"],["舊"],["旧"]],
	[["時"],["時"],["时"]],
	[["曇"],["曇"],["昙"]],
	[["昼"],["晝"],["昼"]],
	[["顕"],["顯"],["显"]],
	[["暁"],["曉"],["晓"]],
	[["晩"],["晚"],["晚"]],
	[["暫"],["暫"],["暂"]],
	[["曽"],["曾"],["曾"]],
	[["術"],["術"],["术"]],
	[["樸"],["樸"],["朴"]],
	[["機"],["機"],["机"]],
	[["殺"],["殺"],["杀"]],
	[["雑"],["雜"],["杂"]],
	[["権"],["權"],["权"]],
	[["条"],["條"],["条"]],
	[["極"],["極"],["极"]],
	[["枢"],["樞"],["枢"]],
	[["槍"],["槍"],["枪"]],
	[["査"],["查"],["查"]],
	[["栄"],["榮"],["荣"]],
	[["標"],["標"],["标"]],
	[["桟"],["棧"],["栈"]],
	[["棟"],["棟"],["栋"]],
	[["欄"],["欄"],["栏"]],
	[["樹"],["樹"],["树"]],
	[["様"],["樣"],["样"]],
	[["桜"],["櫻"],["樱"]],
	[["橋"],["橋"],["桥"]],
	[["検"],["檢"],["检"]],
	[["楼"],["樓"],["楼"]],
	[["歓"],["歡"],["欢"]],
	[["欧"],["歐"],["欧"]],
	[["歩"],["步"],["步"]],
	[["歯"],["齒"],["齿"]],
	[["残"],["殘"],["残"]],
	[["殴"],["毆"],["殴"]],
	[["気"],["氣"],["气"]],
	[["漢"],["漢"],["汉"]],
	[["湯"],["湯"],["汤"]],
	[["溝"],["溝"],["沟"]],
	[["沢"],["澤"],["泽"]],
	[["涙"],["淚"],["泪"]],
	[["滝"],["瀧"],["泷"]],
	[["潔"],["潔"],["洁"]],
	[["浅"],["淺"],["浅"]],
	[["濁"],["濁"],["浊"]],
	[["測"],["測"],["测"]],
	[["済"],["濟"],["济"]],
	[["濃"],["濃"],["浓"]],
	[["浜"],["濱"],["滨"]],
	[["渋"],["涉","澀"],["涉","涩"]],
	[["渦"],["渦"],["涡"]],
	[["潤"],["潤"],["润"]],
	[["漬"],["漬"],["渍"]],
	[["漸"],["漸"],["渐"]],
	[["渓"],["溪"],["溪"]],
	[["漁"],["漁"],["渔"]],
	[["湾"],["灣"],["湾"]],
	[["湿"],["濕"],["湿"]],
	[["満"],["滿"],["满"]],
	[["滅"],["滅"],["灭"]],
	[["滞"],["滯"],["滞"]],
	[["濫"],["濫"],["滥"]],
	[["瀬"],["瀨"],["濑"]],
	[["灯"],["燈"],["灯"]],
	[["霊"],["靈"],["灵"]],
	[["炉"],["爐"],["炉"]],
	[["点"],["點"],["点"]],
	[["錬"],["鍊"],["炼"]],
	[["練"],["練"],["练"]],
	[["煙"],["煙"],["烟"]],
	[["煩"],["煩"],["烦"]],
	[["焼"],["燒"],["烧"]],
	[["熱"],["熱"],["热"]],
	[["焔"],["焰"],["焰"]],
	[["鍛"],["鍛"],["锻"]],
	[["犠"],["犧"],["牺"]],
	[["状"],["狀"],["状"]],
	[["猶"],["猶"],["犹"]],
	[["独"],["獨"],["独"]],
	[["狭"],["狹"],["狭"]],
	[["獄"],["獄"],["狱"]],
	[["猟"],["獵"],["猎"]],
	[["猫"],["貓"],["猫"]],
	[["献"],["獻"],["献"]],
	[["獲"],["獲"],["获"]],
	[["穫"],["穫"],["获"]],
	[["環"],["環"],["环"]],
	[["現"],["現"],["现"]],
	[["璽"],["璽"],["玺"]],
	[["甦"],["甦"],["苏"]],
	[["電"],["電"],["电"]],
	[["療"],["療"],["疗"]],
	[["監"],["監"],["监"]],
	[["蓋"],["蓋"],["盖"]],
	[["盤"],["盤"],["盘"]],
	[["視"],["視"],["视"]],
	[["着"],["著"],["著"]],
	[["矯"],["矯"],["矫"]],
	[["鉱"],["礦"],["矿"]],
	[["砕"],["碎"],["碎"]],
	[["礎"],["礎"],["础"]],
	[["確"],["確"],["确"]],
	[["礼"],["禮"],["礼"]],
	[["禍"],["禍"],["祸"]],
	[["禅"],["禪"],["禅"]],
	[["離"],["離"],["离"]],
	[["種"],["種"],["种"]],
	[["積"],["積"],["积"]],
	[["称"],["稱"],["称"]],
	[["稲"],["稻"],["稻"]],
	[["穏"],["穩"],["稳"]],
	[["穀"],["穀"],["谷"]],
	[["穂"],["穗"],["穗"]],
	[["窮"],["窮"],["穷"]],
	[["窃"],["竊"],["窃"]],
	[["窓"],["窗"],["窗"]],
	[["竜"],["龍"],["龙"]],
	[["競"],["競"],["竞"]],
	[["篤"],["篤"],["笃"]],
	[["筆"],["筆"],["笔"]],
	[["築"],["築"],["筑"]],
	[["簡"],["簡"],["简"]],
	[["箇"],["個"],["个"]],
	[["節"],["節"],["节"]],
	[["範"],["範"],["范"]],
	[["類"],["類"],["类"]],
	[["粋"],["粹"],["粹"]],
	[["粛"],["肅"],["肃"]],
	[["糧"],["糧"],["粮"]],
	[["糾"],["糾"],["纠"]],
	[["紀"],["紀"],["纪"]],
	[["約"],["約"],["约"]],
	[["紅"],["紅"],["红"]],
	[["紋"],["紋"],["纹"]],
	[["納"],["納"],["纳"]],
	[["純"],["純"],["纯"]],
	[["紙"],["紙"],["纸"]],
	[["級"],["級"],["级"]],
	[["紛"],["紛"],["纷"]],
	[["紡"],["紡"],["纺"]],
	[["緊"],["緊"],["紧"]],
	[["細"],["細"],["细"]],
	[["紳"],["紳"],["绅"]],
	[["紹"],["紹"],["绍"]],
	[["紺"],["紺"],["绀"]],
	[["終"],["終"],["终"]],
	[["組"],["組"],["组"]],
	[["経"],["經"],["经"]],
	[["結"],["結"],["结"]],
	[["絶"],["絶"],["绝"]],
	[["絶"],["絕"],["绝"]],
	[["絞"],["絞"],["绞"]],
	[["絡"],["絡"],["络"]],
	[["給"],["給"],["给"]],
	[["統"],["統"],["统"]],
	[["絵"],["繪"],["绘"]],
	[["絹"],["絹"],["绢"]],
	[["継"],["繼"],["继"]],
	[["続"],["續"],["续"]],
	[["緑"],["綠"],["绿"]],
	[["線"],["線"],["线"]],
	[["維"],["維"],["维"]],
	[["綱"],["綱"],["纲"]],
	[["綿"],["綿"],["绵"]],
	[["緒"],["緒"],["绪"]],
	[["締"],["締"],["缔"]],
	[["縁"],["緣"],["缘"]],
	[["編"],["編"],["编"]],
	[["緩"],["緩"],["缓"]],
	[["緯"],["緯"],["纬"]],
	[["縄"],["繩"],["绳"]],
	[["縛"],["縛"],["缚"]],
	[["縦"],["縱"],["纵"]],
	[["縫"],["縫"],["缝"]],
	[["縮"],["縮"],["缩"]],
	[["繊"],["纖"],["纤"]],
	[["績"],["績"],["绩"]],
	[["織"],["織"],["织"]],
	[["繕"],["繕"],["缮"]],
	[["繭"],["繭"],["茧"]],
	[["繰"],["繰"],["缲"]],
	[["缶"],["罐"],["罐"]],
	[["鉢"],["鉢"],["钵"]],
	[["羅"],["羅"],["罗"]],
	[["罸"],["罰"],["罚"]],
	[["罷"],["罷"],["罢"]],
	[["罵"],["罵"],["骂"]],
	[["職"],["職"],["职"]],
	[["聞"],["聞"],["闻"]],
	[["聡"],["聰"],["聪"]],
	[["腸"],["腸"],["肠"]],
	[["膚"],["膚"],["肤"]],
	[["脹"],["脹"],["胀"]],
	[["脅"],["脅"],["胁"]],
	[["胆"],["膽"],["胆"]],
	[["臓"],["臟"],["脏"]],
	[["脳"],["腦"],["脑"]],
	[["脚"],["腳"],["脚"]],
	[["騰"],["騰"],["腾"]],
	[["舗"],["舖"],["铺"]],
	[["館"],["館"],["馆"]],
	[["艦"],["艦"],["舰"]],
	[["芸"],["藝"],["艺"]],
	[["茎"],["莖"],["茎"]],
	[["薦"],["薦"],["荐"]],
	[["荘"],["莊"],["庄"]],
	[["薬"],["藥"],["药"]],
	[["蛍"],["螢"],["萤"]],
	[["蒋"],["蔣"],["蒋"]],
	[["蔵"],["藏"],["藏"]],
	[["虜"],["虜"],["虏"]],
	[["虚"],["虛"],["虚"]],
	[["虫"],["蟲"],["虫"]],
	[["蝕"],["蝕"],["蚀"]],
	[["蚕"],["蠶"],["蚕"]],
	[["蛮"],["蠻"],["蛮"]],
	[["補"],["補"],["补"]],
	[["襲"],["襲"],["袭"]],
	[["装"],["裝"],["装"]],
	[["裏"],["裡"],["里"]],
	[["覇"],["霸"],["霸"]],
	[["見"],["見"],["见"]],
	[["観"],["觀"],["观"]],
	[["規"],["規"],["规"]],
	[["覚"],["覺"],["觉"]],
	[["覧"],["覽"],["览"]],
	[["触"],["觸"],["触"]],
	[["訂"],["訂"],["订"]],
	[["計"],["計"],["计"]],
	[["討"],["討"],["讨"]],
	[["訓"],["訓"],["训"]],
	[["記"],["記"],["记"]],
	[["訟"],["訟"],["讼"]],
	[["訪"],["訪"],["访"]],
	[["設"],["設"],["设"]],
	[["許"],["許"],["许"]],
	[["訳"],["譯"],["译"]],
	[["訴"],["訴"],["诉"]],
	[["診"],["診"],["诊"]],
	[["証"],["證"],["证"]],
	[["詐"],["詐"],["诈"]],
	[["詔"],["詔"],["诏"]],
	[["評"],["評"],["评"]],
	[["詛"],["詛"],["诅"]],
	[["詞"],["詞"],["词"]],
	[["試"],["試"],["试"]],
	[["詩"],["詩"],["诗"]],
	[["詰"],["詰"],["诘"]],
	[["該"],["該"],["该"]],
	[["詳"],["詳"],["详"]],
	[["誉"],["譽"],["誉"]],
	[["謄"],["謄"],["誊"]],
	[["認"],["認"],["认"]],
	[["誕"],["誕"],["诞"]],
	[["誘"],["誘"],["诱"]],
	[["語"],["語"],["语"]],
	[["誠"],["誠"],["诚"]],
	[["誤"],["誤"],["误"]],
	[["説"],["說"],["说"]],
	[["読"],["讀"],["读"]],
	[["誰"],["誰"],["谁"]],
	[["課"],["課"],["课"]],
	[["調"],["調"],["调"]],
	[["談"],["談"],["谈"]],
	[["請"],["請"],["请"]],
	[["論"],["論"],["论"]],
	[["諭"],["諭"],["谕"]],
	[["諸"],["諸"],["诸"]],
	[["諾"],["諾"],["诺"]],
	[["謀"],["謀"],["谋"]],
	[["謁"],["謁"],["谒"]],
	[["謎"],["謎"],["谜"]],
	[["謙"],["謙"],["谦"]],
	[["講"],["講"],["讲"]],
	[["謝"],["謝"],["谢"]],
	[["謡"],["謠"],["谣"]],
	[["謹"],["謹"],["谨"]],
	[["識"],["識"],["识"]],
	[["譜"],["譜"],["谱"]],
	[["議"],["議"],["议"]],
	[["譲"],["讓"],["让"]],
	[["貝"],["貝"],["贝"]],
	[["貞"],["貞"],["贞"]],
	[["負"],["負"],["负"]],
	[["財"],["財"],["财"]],
	[["貢"],["貢"],["贡"]],
	[["貧"],["貧"],["贫"]],
	[["貨"],["貨"],["货"]],
	[["販"],["販"],["贩"]],
	[["貪"],["貪"],["贪"]],
	[["責"],["責"],["责"]],
	[["貯"],["貯"],["贮"]],
	[["貴"],["貴"],["贵"]],
	[["貸"],["貸"],["贷"]],
	[["費"],["費"],["费"]],
	[["貿"],["貿"],["贸"]],
	[["賀"],["賀"],["贺"]],
	[["賃"],["賃"],["赁"]],
	[["賄"],["賄"],["贿"]],
	[["資"],["資"],["资"]],
	[["賊"],["賊"],["贼"]],
	[["賎"],["賤"],["贱"]],
	[["賛"],["贊"],["赞"]],
	[["賜"],["賜"],["赐"]],
	[["賞"],["賞"],["赏"]],
	[["賠"],["賠"],["赔"]],
	[["賢"],["賢"],["贤"]],
	[["賦"],["賦"],["赋"]],
	[["質"],["質"],["质"]],
	[["頼"],["賴"],["赖"]],
	[["贈"],["贈"],["赠"]],
	[["贓"],["贓"],["赃"]],
	[["躍"],["躍"],["跃"]],
	[["践"],["踐"],["践"]],
	[["踪"],["蹤"],["踪"]],
	[["車"],["車"],["车"]],
	[["軌"],["軌"],["轨"]],
	[["軒"],["軒"],["轩"]],
	[["軟"],["軟"],["软"]],
	[["転"],["轉"],["转"]],
	[["軸"],["軸"],["轴"]],
	[["軽"],["輕"],["轻"]],
	[["較"],["較"],["较"]],
	[["載"],["載"],["载"]],
	[["輝"],["輝"],["辉"]],
	[["輩"],["輩"],["辈"]],
	[["輪"],["輪"],["轮"]],
	[["輸"],["輸"],["输"]],
	[["轄"],["轄"],["辖"]],
	[["辞"],["辭"],["辞"]],
	[["辺"],["邊"],["边"]],
	[["達"],["達"],["达"]],
	[["遷"],["遷"],["迁"]],
	[["過"],["過"],["过"]],
	[["運"],["運"],["运"]],
	[["還"],["還"],["还"]],
	[["進"],["進"],["进"]],
	[["遠"],["遠"],["远"]],
	[["違"],["違"],["违"]],
	[["連"],["連"],["连"]],
	[["遅"],["遲"],["迟"]],
	[["適"],["適"],["适"]],
	[["選"],["選"],["选"]],
	[["逓"],["遞"],["递"]],
	[["遺"],["遺"],["遗"]],
	[["遥"],["遙"],["遥"]],
	[["郵"],["郵"],["邮"]],
	[["隣"],["鄰"],["邻"]],
	[["酔"],["醉"],["醉"]],
	[["醸"],["釀"],["酿"]],
	[["釈"],["釋"],["释"]],
	[["針"],["針"],["针"]],
	[["釣"],["釣"],["钓"]],
	[["鈍"],["鈍"],["钝"]],
	[["鈴"],["鈴"],["铃"]],
	[["鉄"],["鐵"],["铁"]],
	[["鉛"],["鉛"],["铅"]],
	[["鑑"],["鑑"],["鉴"]],
	[["銀"],["銀"],["银"]],
	[["銃"],["銃"],["铳"]],
	[["銅"],["銅"],["铜"]],
	[["銑"],["銑"],["铣"]],
	[["銘"],["銘"],["铭"]],
	[["銭"],["錢"],["钱"]],
	[["鋭"],["鋭"],["锐"]],
	[["鋳"],["鑄"],["铸"]],
	[["鋼"],["鋼"],["钢"]],
	[["錘"],["錘"],["锤"]],
	[["錠"],["錠"],["锭"]],
	[["錯"],["錯"],["错"]],
	[["鍾"],["鍾"],["钟"]],
	[["鎖"],["鎖"],["锁"]],
	[["鎮"],["鎮"],["镇"]],
	[["鏡"],["鏡"],["镜"]],
	[["長"],["長"],["长"]],
	[["門"],["門"],["门"]],
	[["閉"],["閉"],["闭"]],
	[["閑"],["閒"],["闲"]],
	[["間"],["間"],["间"]],
	[["閣"],["閣"],["阁"]],
	[["閥"],["閥"],["阀"]],
	[["閲"],["閲"],["阅"]],
	[["隊"],["隊"],["队"]],
	[["陽"],["陽"],["阳"]],
	[["陰"],["陰"],["阴"]],
	[["陣"],["陣"],["阵"]],
	[["階"],["階"],["阶"]],
	[["際"],["際"],["际"]],
	[["陸"],["陸"],["陆"]],
	[["陳"],["陳"],["陈"]],
	[["陥"],["陷"],["陷"]],
	[["随"],["隨"],["随"]],
	[["隠"],["隱"],["隐"]],
	[["隷"],["隷"],["隶"]],
	[["隷"],["隸"],["隶"]],
	[["難"],["難"],["难"]],
	[["鶏"],["雞"],["鸡"]],
	[["鶏"],["鷄"],["鸡"]],
	[["霧"],["霧"],["雾"]],
	[["静"],["靜"],["静"]],
	[["頂"],["頂"],["顶"]],
	[["項"],["項"],["项"]],
	[["順"],["順"],["顺"]],
	[["預"],["預"],["预"]],
	[["頑"],["頑"],["顽"]],
	[["頒"],["頒"],["颁"]],
	[["領"],["領"],["领"]],
	[["頻"],["頻"],["频"]],
	[["題"],["題"],["题"]],
	[["額"],["額"],["额"]],
	[["顔"],["顏"],["颜"]],
	[["風"],["風"],["风"]],
	[["飛"],["飛"],["飞"]],
	[["飢"],["饑"],["饥"]],
	[["飯"],["飯"],["饭"]],
	[["飲"],["飲"],["饮"]],
	[["飼"],["飼"],["饲"]],
	[["飽"],["飽"],["饱"]],
	[["飾"],["飾"],["饰"]],
	[["餓"],["餓"],["饿"]],
	[["馬"],["馬"],["马"]],
	[["駅"],["驛"],["驿"]],
	[["駆"],["驅"],["驱"]],
	[["駐"],["駐"],["驻"]],
	[["騎"],["騎"],["骑"]],
	[["験"],["驗"],["验"]],
	[["騒"],["騷"],["骚"]],
	[["騨"],["驔"],["驔"]],
	[["髄"],["髓"],["髓"]],
	[["髪"],["髮"],[null]],
	[["魚"],["魚"],["鱼"]],
	[["魯"],["魯"],["鲁"]],
	[["鮮"],["鮮"],["鲜"]],
	[["鯨"],["鯨"],["鲸"]],
	[["鳥"],["鳥"],["鸟"]],
	[["鳴"],["鳴"],["鸣"]],
	[["鶫"],["鶇"],["鸫"]],
	[["鶇"],["鶇"],["鸫"]],
	[["麦"],["麥"],["麦"]],
	[["黄"],["黃"],["黄"]],
	[["黒"],["黑"],["黑"]],
	[["黙"],["默"],["默"]],
	[["齢"],["齡"],["龄"]],
];

/**
 * Code generated from @lazy-cjk/jp-table-comparison/lib/table/core.ts;
 * DO NOT EDIT.
 * @see {@link ./table/core.ts}
 */

export const TABLE_SAFE: IKanjiComparisonTable = [
	[["会"],["會"],["会"]],
	[["箋"],["箋"],["笺"]],
	[["網"],["網"],["网"]],
	[["処"],["處"],["处"]],
	[["話"],["話"],["话"]],
	[["万"],["萬"],["万"]],
	[["与"],["與"],["与"]],
	[["醜"],["醜"],["丑"]],
	[["専"],["專"],["专"]],
	[["業"],["業"],["业"]],
	[["東"],["東"],["东"]],
	[["両"],["兩"],["两"]],
	[["厳"],["嚴"],["严"]],
	[["並"],["並"],["并"]],
	[["喪"],["喪"],["丧"]],
	[["豊"],["豐"],["丰"]],
	[["臨"],["臨"],["临"]],
	[["為"],["為"],["为"]],
	[["麗"],["麗"],["丽"]],
	[["挙"],["舉"],["举"]],
	[["廼"],["迺"],["迺"]],
	[["義"],["義"],["义"]],
	[["楽"],["樂"],["乐"]],
	[["乗"],["乘"],["乘"]],
	[["習"],["習"],["习"]],
	[["郷"],["鄉"],["乡"]],
	[["書"],["書"],["书"]],
	[["買"],["買"],["买"]],
	[["乱"],["亂"],["乱"]],
	[["亀"],["龜"],["龟"]],
	[["弐"],["貳"],["贰"]],
	[["雲"],["雲"],["云"]],
	[["亜"],["亞"],["亚"]],
	[["産"],["產"],["产"]],
	[["畝"],["畝"],["亩"]],
	[["親"],["親"],["亲"]],
	[["億"],["億"],["亿"]],
	[["僕"],["僕"],["仆"]],
	[["従"],["從"],["从"]],
	[["仏"],["佛"],["佛"]],
	[["倉"],["倉"],["仓"]],
	[["儀"],["儀"],["仪"]],
	[["仮"],["假"],["假"]],
	[["価"],["價"],["价"]],
	[["衆"],["眾"],["众"]],
	[["優"],["優"],["优"]],
	[["伝"],["傳"],["传"]],
	[["傘"],["傘"],["伞"]],
	[["偉"],["偉"],["伟"]],
	[["傷"],["傷"],["伤"]],
	[["倫"],["倫"],["伦"]],
	[["偽"],["偽"],["伪"]],
	[["体"],["體"],["体"]],
	[["余"],["餘"],["余"]],
	[["来"],["來"],["来"]],
	[["偵"],["偵"],["侦"]],
	[["側"],["側"],["侧"]],
	[["倹"],["儉"],["俭"]],
	[["倶"],["俱"],["俱"]],
	[["債"],["債"],["债"]],
	[["傾"],["傾"],["倾"]],
	[["償"],["償"],["偿"]],
	[["傑"],["傑"],["杰"]],
	[["備"],["備"],["备"]],
	[["当"],["當"],["当"]],
	[["尽"],["盡"],["尽"]],
	[["児"],["兒"],["儿"]],
	[["党"],["黨"],["党"]],
	[["内"],["內"],["内"]],
	[["関"],["關"],["关"]],
	[["興"],["興"],["兴"]],
	[["養"],["養"],["养"]],
	[["獣"],["獸"],["兽"]],
	[["円"],["圓"],["圆"]],
	[["写"],["寫"],["写"]],
	[["軍"],["軍"],["军"]],
	[["農"],["農"],["农"]],
	[["冨"],["富"],["富"]],
	[["氷"],["冰"],["冰"]],
	[["衝"],["衝"],["冲"]],
	[["決"],["決"],["决"]],
	[["凍"],["凍"],["冻"]],
	[["塗"],["塗"],["涂"]],
	[["幾"],["幾"],["几"]],
	[["撃"],["擊"],["击"]],
	[["画"],["劃"],["划"]],
	[["画"],["畫"],["画"]],
	[["則"],["則"],["则"]],
	[["剛"],["剛"],["刚"]],
	[["創"],["創"],["创"]],
	[["別"],["別"],["别"]],
	[["製"],["製"],["制"]],
	[["巻"],["卷"],["卷"]],
	[["刹"],["剎"],["刹"]],
	[["剤"],["劑"],["剂"]],
	[["剣"],["劍"],["剑"]],
	[["劇"],["劇"],["剧"]],
	[["剰"],["剩"],["剩"]],
	[["勧"],["勸"],["劝"]],
	[["務"],["務"],["务"]],
	[["動"],["動"],["动"]],
	[["励"],["勵"],["励"]],
	[["労"],["勞"],["劳"]],
	[["勢"],["勢"],["势"]],
	[["勲"],["勳"],["勋"]],
	[["勝"],["勝"],["胜"]],
	[["区"],["區"],["区"]],
	[["医"],["醫"],["医"]],
	[["華"],["華"],["华"]],
	[["協"],["協"],["协"]],
	[["単"],["單"],["单"]],
	[["売"],["賣"],["卖"]],
	[["衛"],["衛"],["卫"]],
	[["庁"],["廳"],["厅"]],
	[["圧"],["壓"],["压"]],
	[["県"],["縣"],["县"]],
	[["参"],["參"],["参"]],
	[["双"],["雙"],["双"]],
	[["収"],["收"],["收"]],
	[["発"],["發"],["发"]],
	[["変"],["變"],["变"]],
	[["畳"],["疊"],["叠"]],
	[["号"],["號"],["号"]],
	[["嘆"],["嘆"],["叹"]],
	[["嚇"],["嚇"],["吓"]],
	[["聴"],["聽"],["听"]],
	[["啓"],["啟"],["启"]],
	[["員"],["員"],["员"]],
	[["諮"],["諮"],["谘"]],
	[["鹹"],["鹹"],["咸"]],
	[["響"],["響"],["响"]],
	[["問"],["問"],["问"]],
	[["営"],["營"],["营"]],
	[["噴"],["噴"],["喷"]],
	[["嘱"],["囑"],["嘱"]],
	[["蘇"],["蘇"],["苏"]],
	[["団"],["團"],["团"]],
	[["園"],["園"],["园"]],
	[["国"],["國"],["国"]],
	[["囲"],["圍"],["围"]],
	[["図"],["圖"],["图"]],
	[["圏"],["圈"],["圈"]],
	[["聖"],["聖"],["圣"]],
	[["場"],["場"],["场"]],
	[["壊"],["壞"],["坏"]],
	[["塊"],["塊"],["块"]],
	[["堅"],["堅"],["坚"]],
	[["壇"],["壇"],["坛"]],
	[["墳"],["墳"],["坟"]],
	[["墜"],["墜"],["坠"]],
	[["塁"],["壘"],["垒"]],
	[["墾"],["墾"],["垦"]],
	[["執"],["執"],["执"]],
	[["堕"],["墮"],["堕"]],
	[["報"],["報"],["报"]],
	[["塩"],["鹽"],["盐"]],
	[["増"],["增"],["增"]],
	[["壌"],["壤"],["壤"]],
	[["壮"],["壯"],["壮"]],
	[["声"],["聲"],["声"]],
	[["壱"],["壹"],["壹"]],
	[["寿"],["壽"],["寿"]],
	[["夢"],["夢"],["梦"]],
	[["頭"],["頭"],["头"]],
	[["誇"],["誇"],["夸"]],
	[["奪"],["奪"],["夺"]],
	[["奮"],["奮"],["奋"]],
	[["奨"],["獎"],["奖"]],
	[["粧"],["妝"],["妆"]],
	[["婦"],["婦"],["妇"]],
	[["姉"],["姐"],["姐"]],
	[["姫"],["姬"],["姬"]],
	[["嬢"],["孃"],["娘"]],
	[["娯"],["娛"],["娱"]],
	[["孫"],["孫"],["孙"]],
	[["学"],["學"],["学"]],
	[["寧"],["寧"],["宁"]],
	[["宝"],["寶"],["宝"]],
	[["実"],["實"],["实"]],
	[["審"],["審"],["审"]],
	[["憲"],["憲"],["宪"]],
	[["宮"],["宮"],["宫"]],
	[["賓"],["賓"],["宾"]],
	[["秘"],["祕"],["秘"]],
	[["寝"],["寢"],["寝"]],
	[["対"],["對"],["对"]],
	[["尋"],["尋"],["寻"]],
	[["導"],["導"],["导"]],
	[["将"],["將"],["将"]],
	[["層"],["層"],["层"]],
	[["属"],["屬"],["属"]],
	[["歳"],["歲"],["岁"]],
	[["島"],["島"],["岛"]],
	[["巌"],["巖"],["巖"]],
	[["峡"],["峽"],["峡"]],
	[["険"],["險"],["险"]],
	[["幣"],["幣"],["币"]],
	[["帥"],["帥"],["帅"]],
	[["師"],["師"],["师"]],
	[["帳"],["帳"],["帐"]],
	[["帰"],["歸"],["归"]],
	[["広"],["廣"],["广"]],
	[["慶"],["慶"],["庆"]],
	[["庫"],["庫"],["库"]],
	[["応"],["應"],["应"]],
	[["廃"],["廢"],["废"]],
	[["開"],["開"],["开"]],
	[["弁"],["辨","瓣","辯"],["辨","瓣","辩"]],
	[["異"],["異"],["异"]],
	[["棄"],["棄"],["弃"]],
	[["張"],["張"],["张"]],
	[["弥"],["彌"],["弥"]],
	[["強"],["強"],["强"]],
	[["弾"],["彈"],["弹"]],
	[["録"],["錄"],["录"]],
	[["彦"],["彥"],["彥"]],
	[["徹"],["徹"],["彻"]],
	[["徴"],["徵"],["征"]],
	[["径"],["徑"],["径"]],
	[["徳"],["德"],["德"]],
	[["憶"],["憶"],["忆"]],
	[["誌"],["誌"],["志"]],
	[["憂"],["憂"],["忧"]],
	[["懐"],["懷"],["怀"]],
	[["態"],["態"],["态"]],
	[["総"],["總"],["总"]],
	[["恒"],["恆"],["恒"]],
	[["恋"],["戀"],["恋"]],
	[["懇"],["懇"],["恳"]],
	[["恵"],["惠"],["惠"]],
	[["悪"],["惡"],["恶"]],
	[["悩"],["惱"],["恼"]],
	[["悦"],["悅"],["悅"]],
	[["懸"],["懸"],["悬"]],
	[["驚"],["驚"],["惊"]],
	[["惨"],["慘"],["惨"]],
	[["懲"],["懲"],["惩"]],
	[["愛"],["愛"],["爱"]],
	[["憤"],["憤"],["愤"]],
	[["願"],["願"],["愿"]],
	[["慮"],["慮"],["虑"]],
	[["戯"],["戲"],["戏"]],
	[["戦"],["戰"],["战"]],
	[["戸"],["戶"],["户"]],
	[["払"],["拂"],["拂"]],
	[["拡"],["擴"],["扩"]],
	[["掃"],["掃"],["扫"]],
	[["揚"],["揚"],["扬"]],
	[["択"],["擇"],["择"]],
	[["護"],["護"],["护"]],
	[["担"],["擔"],["担"]],
	[["拝"],["拜"],["拜"]],
	[["擬"],["擬"],["拟"]],
	[["拠"],["據"],["据"]],
	[["擁"],["擁"],["拥"]],
	[["挟"],["挾"],["挟"]],
	[["揮"],["揮"],["挥"]],
	[["挿"],["插"],["插"]],
	[["損"],["損"],["损"]],
	[["捨"],["捨"],["舍"]],
	[["掲"],["揭"],["揭"]],
	[["掴"],["摑"],["掴"]],
	[["揺"],["搖"],["摇"]],
	[["敵"],["敵"],["敌"]],
	[["敗"],["敗"],["败"]],
	[["数"],["數"],["数"]],
	[["斉"],["齊"],["齐"]],
	[["斎"],["齋"],["斋"]],
	[["断"],["斷"],["断"]],
	[["旧"],["舊"],["旧"]],
	[["時"],["時"],["时"]],
	[["曇"],["曇"],["昙"]],
	[["昼"],["晝"],["昼"]],
	[["顕"],["顯"],["显"]],
	[["暁"],["曉"],["晓"]],
	[["晩"],["晚"],["晚"]],
	[["暫"],["暫"],["暂"]],
	[["曽"],["曾"],["曾"]],
	[["術"],["術"],["术"]],
	[["樸"],["樸"],["朴"]],
	[["機"],["機"],["机"]],
	[["殺"],["殺"],["杀"]],
	[["雑"],["雜"],["杂"]],
	[["権"],["權"],["权"]],
	[["条"],["條"],["条"]],
	[["極"],["極"],["极"]],
	[["枢"],["樞"],["枢"]],
	[["槍"],["槍"],["枪"]],
	[["査"],["查"],["查"]],
	[["栄"],["榮"],["荣"]],
	[["標"],["標"],["标"]],
	[["桟"],["棧"],["栈"]],
	[["棟"],["棟"],["栋"]],
	[["欄"],["欄"],["栏"]],
	[["樹"],["樹"],["树"]],
	[["様"],["樣"],["样"]],
	[["桜"],["櫻"],["樱"]],
	[["橋"],["橋"],["桥"]],
	[["検"],["檢"],["检"]],
	[["楼"],["樓"],["楼"]],
	[["歓"],["歡"],["欢"]],
	[["欧"],["歐"],["欧"]],
	[["歩"],["步"],["步"]],
	[["歯"],["齒"],["齿"]],
	[["残"],["殘"],["残"]],
	[["殴"],["毆"],["殴"]],
	[["気"],["氣"],["气"]],
	[["漢"],["漢"],["汉"]],
	[["湯"],["湯"],["汤"]],
	[["溝"],["溝"],["沟"]],
	[["沢"],["澤"],["泽"]],
	[["涙"],["淚"],["泪"]],
	[["滝"],["瀧"],["泷"]],
	[["潔"],["潔"],["洁"]],
	[["浅"],["淺"],["浅"]],
	[["濁"],["濁"],["浊"]],
	[["測"],["測"],["测"]],
	[["済"],["濟"],["济"]],
	[["濃"],["濃"],["浓"]],
	[["浜"],["濱"],["滨"]],
	[["渋"],["涉","澀"],["涉","涩"]],
	[["渦"],["渦"],["涡"]],
	[["潤"],["潤"],["润"]],
	[["漬"],["漬"],["渍"]],
	[["漸"],["漸"],["渐"]],
	[["渓"],["溪"],["溪"]],
	[["漁"],["漁"],["渔"]],
	[["湾"],["灣"],["湾"]],
	[["湿"],["濕"],["湿"]],
	[["満"],["滿"],["满"]],
	[["滅"],["滅"],["灭"]],
	[["滞"],["滯"],["滞"]],
	[["濫"],["濫"],["滥"]],
	[["瀬"],["瀨"],["濑"]],
	[["灯"],["燈"],["灯"]],
	[["霊"],["靈"],["灵"]],
	[["炉"],["爐"],["炉"]],
	[["点"],["點"],["点"]],
	[["錬"],["鍊"],["炼"]],
	[["練"],["練"],["练"]],
	[["煙"],["煙"],["烟"]],
	[["煩"],["煩"],["烦"]],
	[["焼"],["燒"],["烧"]],
	[["熱"],["熱"],["热"]],
	[["焔"],["焰"],["焰"]],
	[["鍛"],["鍛"],["锻"]],
	[["犠"],["犧"],["牺"]],
	[["状"],["狀"],["状"]],
	[["猶"],["猶"],["犹"]],
	[["独"],["獨"],["独"]],
	[["狭"],["狹"],["狭"]],
	[["獄"],["獄"],["狱"]],
	[["猟"],["獵"],["猎"]],
	[["猫"],["貓"],["猫"]],
	[["献"],["獻"],["献"]],
	[["環"],["環"],["环"]],
	[["現"],["現"],["现"]],
	[["璽"],["璽"],["玺"]],
	[["電"],["電"],["电"]],
	[["療"],["療"],["疗"]],
	[["監"],["監"],["监"]],
	[["蓋"],["蓋"],["盖"]],
	[["盤"],["盤"],["盘"]],
	[["視"],["視"],["视"]],
	[["着"],["著"],["著"]],
	[["矯"],["矯"],["矫"]],
	[["鉱"],["礦"],["矿"]],
	[["砕"],["碎"],["碎"]],
	[["礎"],["礎"],["础"]],
	[["確"],["確"],["确"]],
	[["礼"],["禮"],["礼"]],
	[["禍"],["禍"],["祸"]],
	[["禅"],["禪"],["禅"]],
	[["離"],["離"],["离"]],
	[["種"],["種"],["种"]],
	[["積"],["積"],["积"]],
	[["称"],["稱"],["称"]],
	[["稲"],["稻"],["稻"]],
	[["穏"],["穩"],["稳"]],
	[["穀"],["穀"],["谷"]],
	[["穂"],["穗"],["穗"]],
	[["窮"],["窮"],["穷"]],
	[["窃"],["竊"],["窃"]],
	[["窓"],["窗"],["窗"]],
	[["竜"],["龍"],["龙"]],
	[["競"],["競"],["竞"]],
	[["篤"],["篤"],["笃"]],
	[["筆"],["筆"],["笔"]],
	[["築"],["築"],["筑"]],
	[["簡"],["簡"],["简"]],
	[["節"],["節"],["节"]],
	[["範"],["範"],["范"]],
	[["類"],["類"],["类"]],
	[["粋"],["粹"],["粹"]],
	[["粛"],["肅"],["肃"]],
	[["糧"],["糧"],["粮"]],
	[["糾"],["糾"],["纠"]],
	[["紀"],["紀"],["纪"]],
	[["約"],["約"],["约"]],
	[["紅"],["紅"],["红"]],
	[["紋"],["紋"],["纹"]],
	[["納"],["納"],["纳"]],
	[["純"],["純"],["纯"]],
	[["紙"],["紙"],["纸"]],
	[["級"],["級"],["级"]],
	[["紛"],["紛"],["纷"]],
	[["紡"],["紡"],["纺"]],
	[["緊"],["緊"],["紧"]],
	[["細"],["細"],["细"]],
	[["紳"],["紳"],["绅"]],
	[["紹"],["紹"],["绍"]],
	[["紺"],["紺"],["绀"]],
	[["終"],["終"],["终"]],
	[["組"],["組"],["组"]],
	[["経"],["經"],["经"]],
	[["結"],["結"],["结"]],
	[["絶"],["絕"],["绝"]],
	[["絞"],["絞"],["绞"]],
	[["絡"],["絡"],["络"]],
	[["給"],["給"],["给"]],
	[["統"],["統"],["统"]],
	[["絵"],["繪"],["绘"]],
	[["絹"],["絹"],["绢"]],
	[["継"],["繼"],["继"]],
	[["続"],["續"],["续"]],
	[["緑"],["綠"],["绿"]],
	[["線"],["線"],["线"]],
	[["維"],["維"],["维"]],
	[["綱"],["綱"],["纲"]],
	[["綿"],["綿"],["绵"]],
	[["緒"],["緒"],["绪"]],
	[["締"],["締"],["缔"]],
	[["縁"],["緣"],["缘"]],
	[["編"],["編"],["编"]],
	[["緩"],["緩"],["缓"]],
	[["緯"],["緯"],["纬"]],
	[["縄"],["繩"],["绳"]],
	[["縛"],["縛"],["缚"]],
	[["縦"],["縱"],["纵"]],
	[["縫"],["縫"],["缝"]],
	[["縮"],["縮"],["缩"]],
	[["繊"],["纖"],["纤"]],
	[["績"],["績"],["绩"]],
	[["織"],["織"],["织"]],
	[["繕"],["繕"],["缮"]],
	[["繭"],["繭"],["茧"]],
	[["繰"],["繰"],["缲"]],
	[["缶"],["罐"],["罐"]],
	[["鉢"],["鉢"],["钵"]],
	[["羅"],["羅"],["罗"]],
	[["罸"],["罰"],["罚"]],
	[["罷"],["罷"],["罢"]],
	[["罵"],["罵"],["骂"]],
	[["職"],["職"],["职"]],
	[["聞"],["聞"],["闻"]],
	[["聡"],["聰"],["聪"]],
	[["腸"],["腸"],["肠"]],
	[["膚"],["膚"],["肤"]],
	[["脹"],["脹"],["胀"]],
	[["脅"],["脅"],["胁"]],
	[["胆"],["膽"],["胆"]],
	[["臓"],["臟"],["脏"]],
	[["脳"],["腦"],["脑"]],
	[["脚"],["腳"],["脚"]],
	[["騰"],["騰"],["腾"]],
	[["舗"],["舖"],["铺"]],
	[["館"],["館"],["馆"]],
	[["艦"],["艦"],["舰"]],
	[["芸"],["藝"],["艺"]],
	[["茎"],["莖"],["茎"]],
	[["薦"],["薦"],["荐"]],
	[["薬"],["藥"],["药"]],
	[["蛍"],["螢"],["萤"]],
	[["蒋"],["蔣"],["蒋"]],
	[["蔵"],["藏"],["藏"]],
	[["虜"],["虜"],["虏"]],
	[["虚"],["虛"],["虚"]],
	[["虫"],["蟲"],["虫"]],
	[["蝕"],["蝕"],["蚀"]],
	[["蚕"],["蠶"],["蚕"]],
	[["蛮"],["蠻"],["蛮"]],
	[["補"],["補"],["补"]],
	[["襲"],["襲"],["袭"]],
	[["装"],["裝"],["装"]],
	[["裏"],["裡"],["里"]],
	[["覇"],["霸"],["霸"]],
	[["見"],["見"],["见"]],
	[["観"],["觀"],["观"]],
	[["規"],["規"],["规"]],
	[["覚"],["覺"],["觉"]],
	[["覧"],["覽"],["览"]],
	[["触"],["觸"],["触"]],
	[["訂"],["訂"],["订"]],
	[["計"],["計"],["计"]],
	[["討"],["討"],["讨"]],
	[["訓"],["訓"],["训"]],
	[["記"],["記"],["记"]],
	[["訟"],["訟"],["讼"]],
	[["訪"],["訪"],["访"]],
	[["設"],["設"],["设"]],
	[["許"],["許"],["许"]],
	[["訳"],["譯"],["译"]],
	[["訴"],["訴"],["诉"]],
	[["診"],["診"],["诊"]],
	[["証"],["證"],["证"]],
	[["詐"],["詐"],["诈"]],
	[["詔"],["詔"],["诏"]],
	[["評"],["評"],["评"]],
	[["詛"],["詛"],["诅"]],
	[["詞"],["詞"],["词"]],
	[["試"],["試"],["试"]],
	[["詩"],["詩"],["诗"]],
	[["詰"],["詰"],["诘"]],
	[["該"],["該"],["该"]],
	[["詳"],["詳"],["详"]],
	[["誉"],["譽"],["誉"]],
	[["謄"],["謄"],["誊"]],
	[["認"],["認"],["认"]],
	[["誕"],["誕"],["诞"]],
	[["誘"],["誘"],["诱"]],
	[["語"],["語"],["语"]],
	[["誠"],["誠"],["诚"]],
	[["誤"],["誤"],["误"]],
	[["説"],["說"],["说"]],
	[["読"],["讀"],["读"]],
	[["誰"],["誰"],["谁"]],
	[["課"],["課"],["课"]],
	[["調"],["調"],["调"]],
	[["談"],["談"],["谈"]],
	[["請"],["請"],["请"]],
	[["論"],["論"],["论"]],
	[["諭"],["諭"],["谕"]],
	[["諸"],["諸"],["诸"]],
	[["諾"],["諾"],["诺"]],
	[["謀"],["謀"],["谋"]],
	[["謁"],["謁"],["谒"]],
	[["謎"],["謎"],["谜"]],
	[["謙"],["謙"],["谦"]],
	[["講"],["講"],["讲"]],
	[["謝"],["謝"],["谢"]],
	[["謡"],["謠"],["谣"]],
	[["謹"],["謹"],["谨"]],
	[["識"],["識"],["识"]],
	[["譜"],["譜"],["谱"]],
	[["議"],["議"],["议"]],
	[["譲"],["讓"],["让"]],
	[["貝"],["貝"],["贝"]],
	[["貞"],["貞"],["贞"]],
	[["負"],["負"],["负"]],
	[["財"],["財"],["财"]],
	[["貢"],["貢"],["贡"]],
	[["貧"],["貧"],["贫"]],
	[["貨"],["貨"],["货"]],
	[["販"],["販"],["贩"]],
	[["貪"],["貪"],["贪"]],
	[["責"],["責"],["责"]],
	[["貯"],["貯"],["贮"]],
	[["貴"],["貴"],["贵"]],
	[["貸"],["貸"],["贷"]],
	[["費"],["費"],["费"]],
	[["貿"],["貿"],["贸"]],
	[["賀"],["賀"],["贺"]],
	[["賃"],["賃"],["赁"]],
	[["賄"],["賄"],["贿"]],
	[["資"],["資"],["资"]],
	[["賊"],["賊"],["贼"]],
	[["賎"],["賤"],["贱"]],
	[["賛"],["贊"],["赞"]],
	[["賜"],["賜"],["赐"]],
	[["賞"],["賞"],["赏"]],
	[["賠"],["賠"],["赔"]],
	[["賢"],["賢"],["贤"]],
	[["賦"],["賦"],["赋"]],
	[["質"],["質"],["质"]],
	[["頼"],["賴"],["赖"]],
	[["贈"],["贈"],["赠"]],
	[["贓"],["贓"],["赃"]],
	[["躍"],["躍"],["跃"]],
	[["践"],["踐"],["践"]],
	[["踪"],["蹤"],["踪"]],
	[["車"],["車"],["车"]],
	[["軌"],["軌"],["轨"]],
	[["軒"],["軒"],["轩"]],
	[["軟"],["軟"],["软"]],
	[["転"],["轉"],["转"]],
	[["軸"],["軸"],["轴"]],
	[["軽"],["輕"],["轻"]],
	[["較"],["較"],["较"]],
	[["載"],["載"],["载"]],
	[["輝"],["輝"],["辉"]],
	[["輩"],["輩"],["辈"]],
	[["輪"],["輪"],["轮"]],
	[["輸"],["輸"],["输"]],
	[["轄"],["轄"],["辖"]],
	[["辞"],["辭"],["辞"]],
	[["辺"],["邊"],["边"]],
	[["達"],["達"],["达"]],
	[["遷"],["遷"],["迁"]],
	[["過"],["過"],["过"]],
	[["運"],["運"],["运"]],
	[["還"],["還"],["还"]],
	[["進"],["進"],["进"]],
	[["遠"],["遠"],["远"]],
	[["違"],["違"],["违"]],
	[["連"],["連"],["连"]],
	[["遅"],["遲"],["迟"]],
	[["適"],["適"],["适"]],
	[["選"],["選"],["选"]],
	[["逓"],["遞"],["递"]],
	[["遺"],["遺"],["遗"]],
	[["遥"],["遙"],["遥"]],
	[["郵"],["郵"],["邮"]],
	[["隣"],["鄰"],["邻"]],
	[["酔"],["醉"],["醉"]],
	[["醸"],["釀"],["酿"]],
	[["釈"],["釋"],["释"]],
	[["針"],["針"],["针"]],
	[["釣"],["釣"],["钓"]],
	[["鈍"],["鈍"],["钝"]],
	[["鈴"],["鈴"],["铃"]],
	[["鉄"],["鐵"],["铁"]],
	[["鉛"],["鉛"],["铅"]],
	[["鑑"],["鑑"],["鉴"]],
	[["銀"],["銀"],["银"]],
	[["銃"],["銃"],["铳"]],
	[["銅"],["銅"],["铜"]],
	[["銑"],["銑"],["铣"]],
	[["銘"],["銘"],["铭"]],
	[["銭"],["錢"],["钱"]],
	[["鋭"],["鋭"],["锐"]],
	[["鋳"],["鑄"],["铸"]],
	[["鋼"],["鋼"],["钢"]],
	[["錘"],["錘"],["锤"]],
	[["錠"],["錠"],["锭"]],
	[["錯"],["錯"],["错"]],
	[["鍾"],["鍾"],["钟"]],
	[["鎖"],["鎖"],["锁"]],
	[["鎮"],["鎮"],["镇"]],
	[["鏡"],["鏡"],["镜"]],
	[["長"],["長"],["长"]],
	[["門"],["門"],["门"]],
	[["閉"],["閉"],["闭"]],
	[["閑"],["閒"],["闲"]],
	[["間"],["間"],["间"]],
	[["閣"],["閣"],["阁"]],
	[["閥"],["閥"],["阀"]],
	[["閲"],["閲"],["阅"]],
	[["隊"],["隊"],["队"]],
	[["陽"],["陽"],["阳"]],
	[["陰"],["陰"],["阴"]],
	[["陣"],["陣"],["阵"]],
	[["階"],["階"],["阶"]],
	[["際"],["際"],["际"]],
	[["陸"],["陸"],["陆"]],
	[["陳"],["陳"],["陈"]],
	[["陥"],["陷"],["陷"]],
	[["随"],["隨"],["随"]],
	[["隠"],["隱"],["隐"]],
	[["隷"],["隸"],["隶"]],
	[["難"],["難"],["难"]],
	[["霧"],["霧"],["雾"]],
	[["静"],["靜"],["静"]],
	[["頂"],["頂"],["顶"]],
	[["項"],["項"],["项"]],
	[["順"],["順"],["顺"]],
	[["頑"],["頑"],["顽"]],
	[["頒"],["頒"],["颁"]],
	[["領"],["領"],["领"]],
	[["頻"],["頻"],["频"]],
	[["題"],["題"],["题"]],
	[["額"],["額"],["额"]],
	[["顔"],["顏"],["颜"]],
	[["風"],["風"],["风"]],
	[["飛"],["飛"],["飞"]],
	[["飢"],["饑"],["饥"]],
	[["飯"],["飯"],["饭"]],
	[["飲"],["飲"],["饮"]],
	[["飼"],["飼"],["饲"]],
	[["飽"],["飽"],["饱"]],
	[["飾"],["飾"],["饰"]],
	[["餓"],["餓"],["饿"]],
	[["馬"],["馬"],["马"]],
	[["駅"],["驛"],["驿"]],
	[["駆"],["驅"],["驱"]],
	[["駐"],["駐"],["驻"]],
	[["騎"],["騎"],["骑"]],
	[["験"],["驗"],["验"]],
	[["騒"],["騷"],["骚"]],
	[["騨"],["驔"],["驔"]],
	[["髄"],["髓"],["髓"]],
	[["魚"],["魚"],["鱼"]],
	[["魯"],["魯"],["鲁"]],
	[["鮮"],["鮮"],["鲜"]],
	[["鯨"],["鯨"],["鲸"]],
	[["鳥"],["鳥"],["鸟"]],
	[["鳴"],["鳴"],["鸣"]],
	[["麦"],["麥"],["麦"]],
	[["黄"],["黃"],["黄"]],
	[["黒"],["黑"],["黑"]],
	[["黙"],["默"],["默"]],
	[["齢"],["齡"],["龄"]],
];

